import { useEffect, useRef } from "react";

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.classList.add("opacity-100", "translate-y-0");
    }
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e7e24e20ccf815cf77ed6c94dd45815f.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-[#0a0a0a]" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 text-center">
        {/* Tag */}
        <div className="inline-flex items-center gap-2 bg-emerald-400/10 border border-emerald-400/30 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse block" />
          <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase">
            iOS Excellence
          </span>
        </div>

        {/* Headline */}
        <h1
          ref={titleRef}
          className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6 opacity-0 translate-y-8 transition-all duration-1000"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Secure &amp; Optimize
          <br />
          <span className="text-emerald-400">Your iOS Experience</span>
        </h1>

        {/* Subtitle */}
        <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-12">
          JEKO, d.o.o. engineers premium applications that protect your privacy
          and maximize device performance — built exclusively for iOS.
        </p>

        {/* Stats row */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-12 mt-8">
          {[
            { value: "2", label: "Flagship Products" },
            { value: "256-bit", label: "Encryption Standard" },
            { value: "iOS", label: "Platform Focus" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-3xl font-bold text-emerald-400 mb-1"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm tracking-widest uppercase">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="text-gray-500 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-0.5 h-10 bg-gradient-to-b from-gray-500 to-transparent" />
      </div>
    </section>
  );
}
